import styled from 'styled-components';
import { SYSTEM_ALERT_BANNER_HEIGHT, Z_INDEX_TOP } from '#/shared/constants';

export const AlertListWrapper = styled.div`
  position: fixed;
  display: flex;
  flex-direction: column;
  align-items: stretch;
  width: 100%;
  cursor: initial;
  z-index: ${Z_INDEX_TOP};
`;

export const AlertRow = styled.div`
  height: ${SYSTEM_ALERT_BANNER_HEIGHT};
  background-color: transparent;
`;
